export default __webpack_public_path__ + "static/media/radio-select.6aa4406c.svg";